export const API = "https://all-about-hair-backend.onrender.com/api/";
// export const API = "http://localhost:8081/api/";